function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, forwardRef, useRef } from "react";
import { Table, Tag, Image, Alert, Button, Drawer, Space, Card, Skeleton, Descriptions, Statistic, List, Divider } from "antd";
import Moment from "react-moment";
import { Container, Row, Col } from "react-bootstrap";
import { PrinterFill, CheckCircleFill, HouseFill, Link, Globe, TelephoneFill, CashCoin, Truck, Cash, CartCheckFill, GeoAltFill, EnvelopeAtFill, GraphUpArrow, ClockHistory, AwardFill, XCircleFill } from "react-bootstrap-icons";
import DisplayInvoice from "./DisplayInvoice";
import SportsModeIcon from '@iconify-react/flat-color-icons/sports-mode';
import Receipt from "./Receipt";
import ReactToPrint, { PrintContextConsumer, useReactToPrint } from 'react-to-print';
import Common from "./includes/Common";
import moment from 'moment';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var CustomerDetails = function CustomerDetails(_ref) {
  var _ref$customer_id = _ref.customer_id,
    customer_id = _ref$customer_id === void 0 ? null : _ref$customer_id;
  var ref = useRef();
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    bills = _useState2[0],
    setBills = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    settlements = _useState4[0],
    setSettlements = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showBill = _useState6[0],
    setShowBill = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showReceipt = _useState8[0],
    setShowReceipt = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    selectedBill = _useState0[0],
    setSelectedBill = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    selectedSettlement = _useState10[0],
    setSelectedSettlement = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    customer = _useState12[0],
    setCustomer = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    customerOrders = _useState14[0],
    setCustomerOrders = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    customerStats = _useState16[0],
    setCustomerStats = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isDataChanged = _useState18[0],
    setIsDataChanged = _useState18[1];
  var _useState19 = useState(''),
    _useState20 = _slicedToArray(_useState19, 2),
    loadError = _useState20[0],
    setLoadError = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    isDataLoading = _useState22[0],
    setIsDataLoading = _useState22[1];
  var _useState23 = useState(null),
    _useState24 = _slicedToArray(_useState23, 2),
    selectedOrder = _useState24[0],
    setSelectedOrder = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    showAssignDelivery = _useState26[0],
    setShowAssignDelivery = _useState26[1];
  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    showEditAssignDelivery = _useState28[0],
    setShowEditAssignDelivery = _useState28[1];
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    showInvoice = _useState30[0],
    setShowInvoice = _useState30[1];
  useEffect(function () {
    setIsDataChanged(false);
    if (customer_id == null) return;
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getcustomerdetails/" + customer_id + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setCustomerOrders([]);
        setCustomerStats([]);
        setCustomer(response.data.customer);
        setCustomerOrders(response.data.orders);
        setCustomerStats(response.data.stats);
      } else {
        setLoadError(response.data.message);
      }
    })["catch"](function (error) {
      setLoadError("Une erreur est survénue " + error.toString());
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [customer ? /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 8,
          md: 8,
          children: /*#__PURE__*/_jsx("div", {
            style: _defineProperty({
              background: "#FFFFFF",
              borderRadius: "8px",
              boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
              padding: "18px"
            }, "padding", "18px"),
            children: /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                children: /*#__PURE__*/_jsx(HouseFill, {
                  color: "#154FA8",
                  size: 45
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 10,
                md: 10,
                children: /*#__PURE__*/_jsxs(Space, {
                  orientation: "vertical",
                  children: [/*#__PURE__*/_jsxs(Space, {
                    children: [/*#__PURE__*/_jsx("h5", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: customer.name
                      })
                    }), /*#__PURE__*/_jsx(Tag, {
                      color: "default",
                      children: " Etablissement"
                    })]
                  }), /*#__PURE__*/_jsxs("p", {
                    style: {
                      color: "#736b6b"
                    },
                    children: ["Client entreprise depuis le ", /*#__PURE__*/_jsx(Moment, {
                      date: customer.created_at,
                      format: "DD/MM/YYYYY"
                    })]
                  }), /*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 4,
                      md: 4,
                      sm: 4,
                      children: /*#__PURE__*/_jsx("div", {
                        style: {
                          fontWeight: "bold",
                          padding: "8px 16px",
                          minWidth: "130px",
                          borderRadius: "5px",
                          background: "#F4F4F5"
                        },
                        children: /*#__PURE__*/_jsxs(Space, {
                          orientation: "vertical",
                          children: [/*#__PURE__*/_jsx("h6", {
                            children: "CODE CLIENT"
                          }), /*#__PURE__*/_jsxs("b", {
                            children: ["ENT-00", customer.id]
                          })]
                        })
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 4,
                      md: 4,
                      sm: 4,
                      children: /*#__PURE__*/_jsx("div", {
                        style: {
                          fontWeight: "bold",
                          padding: "8px 16px",
                          borderRadius: "5px",
                          background: "#F4F4F5"
                        },
                        children: /*#__PURE__*/_jsxs(Space, {
                          orientation: "vertical",
                          children: [/*#__PURE__*/_jsx("h6", {
                            children: "TYPE"
                          }), /*#__PURE__*/_jsx("b", {
                            children: "Entreprise"
                          })]
                        })
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 4,
                      md: 4,
                      sm: 4,
                      children: /*#__PURE__*/_jsx("div", {
                        style: {
                          fontWeight: "bold",
                          padding: "8px 16px",
                          borderRadius: "5px",
                          background: "#F4F4F5"
                        },
                        children: /*#__PURE__*/_jsxs(Space, {
                          orientation: "vertical",
                          children: [/*#__PURE__*/_jsx("h6", {
                            children: "CREE LE"
                          }), /*#__PURE__*/_jsx(Moment, {
                            date: customer.created_at,
                            format: "DD/MM/YYYY"
                          })]
                        })
                      })
                    })]
                  })]
                })
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx("div", {
            style: {
              background: "#FFFFFF",
              borderRadius: "8px",
              boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
              padding: "18px"
            },
            children: /*#__PURE__*/_jsxs(Space, {
              orientation: "vertical",
              children: [/*#__PURE__*/_jsxs(Space, {
                children: [/*#__PURE__*/_jsx(Link, {}), /*#__PURE__*/_jsx("h6", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "Informations de contact"
                  })
                })]
              }), /*#__PURE__*/_jsxs(Space, {
                children: [/*#__PURE__*/_jsx(TelephoneFill, {
                  size: 20
                }), /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsx("div", {
                    style: {
                      color: "#736b6b"
                    },
                    children: "T\xE9l\xE9phone"
                  }), /*#__PURE__*/_jsx("div", {
                    children: customer.mobile
                  })]
                })]
              }), /*#__PURE__*/_jsxs(Space, {
                children: [/*#__PURE__*/_jsx(EnvelopeAtFill, {
                  size: 20
                }), /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsx("div", {
                    style: {
                      color: "#736b6b"
                    },
                    children: "E-mail"
                  }), /*#__PURE__*/_jsx("div", {
                    children: customer.email
                  })]
                })]
              }), /*#__PURE__*/_jsxs(Space, {
                children: [/*#__PURE__*/_jsx(Globe, {
                  size: 20
                }), /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsx("div", {
                    style: {
                      color: "#736b6b"
                    },
                    children: "Site web"
                  }), /*#__PURE__*/_jsx("div", {
                    children: customer.website
                  })]
                })]
              })]
            })
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx("div", {
            style: {
              background: "#FFFFFF",
              borderRadius: "8px",
              boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
              padding: "18px"
            },
            children: /*#__PURE__*/_jsx(Descriptions, {
              column: 2,
              title: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(GeoAltFill, {
                  size: 24
                }), " Addresses de livraison"]
              }),
              items: [{
                key: 1,
                label: /*#__PURE__*/_jsx("b", {
                  children: "Adrese principale"
                }),
                children: /*#__PURE__*/_jsx("span", {
                  children: customer.address
                })
              }],
              extra: /*#__PURE__*/_jsx(Button, {
                type: "primary",
                children: /*#__PURE__*/_jsx("b", {
                  children: "Voir sur la carte"
                })
              })
            })
          })
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              background: "#FFFFFF",
              borderRadius: "8px",
              boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
              padding: "18px"
            },
            children: [/*#__PURE__*/_jsxs(Space, {
              children: [/*#__PURE__*/_jsx(GraphUpArrow, {}), /*#__PURE__*/_jsx("h6", {
                children: /*#__PURE__*/_jsx("b", {
                  children: " Statistiques"
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                sm: 6,
                children: /*#__PURE__*/_jsx(Card, {
                  variant: "borderless",
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: "Commandes valid\xE9es",
                    value: customerStats.validated_order_count,
                    precision: 0,
                    styles: {
                      content: {
                        color: '#037380'
                      }
                    },
                    prefix: /*#__PURE__*/_jsx(CartCheckFill, {
                      size: 25
                    })
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                sm: 6,
                children: /*#__PURE__*/_jsx(Card, {
                  variant: "borderless",
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: "Commandes livr\xE9es",
                    value: customerStats.delivered_order_count,
                    precision: 0,
                    styles: {
                      content: {
                        color: '#0447A5'
                      }
                    },
                    prefix: /*#__PURE__*/_jsx(Truck, {
                      size: 25
                    })
                  })
                })
              })]
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
              children: /*#__PURE__*/_jsx(Col, {
                lg: 12,
                md: 12,
                sm: 12,
                children: /*#__PURE__*/_jsx(Card, {
                  variant: "borderless",
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: "Montant commandes",
                    value: customerStats.order_amount,
                    precision: 0,
                    styles: {
                      content: {
                        color: '#C07E54'
                      }
                    },
                    prefix: /*#__PURE__*/_jsx(CashCoin, {
                      size: 25
                    }),
                    suffix: "GnF"
                  })
                })
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 8,
          md: 8,
          children: /*#__PURE__*/_jsxs("div", {
            style: _defineProperty({
              background: "#FFFFFF",
              borderRadius: "8px",
              boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
              padding: "18px"
            }, "padding", "18px"),
            children: [/*#__PURE__*/_jsxs(Space, {
              children: [/*#__PURE__*/_jsx(ClockHistory, {
                size: 18
              }), /*#__PURE__*/_jsx("h6", {
                children: /*#__PURE__*/_jsx("b", {
                  children: " Historique des activit\xE9s"
                })
              })]
            }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(List, {
              loading: isDataLoading,
              itemLayout: "horizontal",
              dataSource: customerOrders,
              renderItem: function renderItem(item) {
                return /*#__PURE__*/_jsx(List.Item, {
                  actions: [/*#__PURE__*/_jsxs(Space, {
                    direction: "horizontal",
                    children: [item.status == Common.orderStatus.CONFIRMED_PAID && /*#__PURE__*/_jsx(Button, {
                      type: "default",
                      onClick: function onClick() {
                        setSelectedOrder(item);
                        setShowAssignDelivery(true);
                      },
                      children: /*#__PURE__*/_jsxs("b", {
                        children: [/*#__PURE__*/_jsx(SportsModeIcon, {
                          height: "17px"
                        }), " Ass. Livreur"]
                      })
                    }), item.status == Common.orderStatus.ASSIGNED && /*#__PURE__*/_jsx(Button, {
                      icon: /*#__PURE__*/_jsx(PencilSquare, {}),
                      type: "default",
                      onClick: function onClick() {
                        setSelectedOrder(item);
                        setShowEditAssignDelivery(true);
                      },
                      children: /*#__PURE__*/_jsx("b", {
                        children: /*#__PURE__*/_jsx(SportsModeIcon, {
                          height: "17px"
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx(Button, {
                    type: "default",
                    onClick: function onClick() {
                      setSelectedOrder(item);
                      setShowInvoice(true);
                    },
                    children: /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx(PrinterFill, {
                        size: 18
                      })
                    })
                  })],
                  children: /*#__PURE__*/_jsx(Skeleton, {
                    avatar: true,
                    title: false,
                    loading: isDataLoading,
                    active: true,
                    children: /*#__PURE__*/_jsx(List.Item.Meta, {
                      title: /*#__PURE__*/_jsxs(Space, {
                        direction: "horizontal",
                        children: [/*#__PURE__*/_jsxs("div", {
                          children: [item.status == 0 && /*#__PURE__*/_jsx(ClockHistory, {
                            style: {
                              color: '#ED8042'
                            },
                            size: 20
                          }), "     ", item.status == 1 && /*#__PURE__*/_jsx(CheckCircleFill, {
                            style: {
                              color: '#85D58C'
                            },
                            size: 20
                          }), "  ", item.status == 2 && /*#__PURE__*/_jsx(SportsModeIcon, {
                            height: "28px"
                          }), "                             ", item.status == 3 && /*#__PURE__*/_jsx(Truck, {
                            style: {
                              color: '#0C4AA6'
                            },
                            size: 20
                          }), "            ", item.status == 4 && /*#__PURE__*/_jsx(AwardFill, {
                            style: {
                              color: '#0C4AA6'
                            },
                            size: 20
                          }), "        ", item.status == 5 && /*#__PURE__*/_jsx(XCircleFill, {
                            style: {
                              color: '#ae473e'
                            },
                            size: 20
                          }), "        "]
                        }), /*#__PURE__*/_jsxs("b", {
                          children: ["COMMANDE N\xB0C0", item.id]
                        }), /*#__PURE__*/_jsxs("b", {
                          children: [" Le ", /*#__PURE__*/_jsx(Moment, {
                            date: item.created_at,
                            format: "DD/MM/YYYY HH:mm"
                          })]
                        })]
                      }),
                      description: /*#__PURE__*/_jsxs(Space, {
                        children: [/*#__PURE__*/_jsx(Cash, {
                          color: "#D6423F",
                          size: 20
                        }), /*#__PURE__*/_jsx("span", {
                          style: {
                            fontWeight: "bold",
                            color: "#D6423F"
                          },
                          children: item.total_amount.toLocaleString("Fr") + " GnF "
                        })]
                      })
                    })
                  })
                });
              }
            })]
          })
        })]
      })]
    }) : /*#__PURE__*/_jsx(Skeleton, {
      active: true
    }), selectedOrder && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "DETAILS DEVIS"
        }),
        width: "395px",
        open: showInvoice,
        onClose: function onClose() {
          setShowInvoice(false);
        },
        destroyOnClose: true,
        extra: /*#__PURE__*/_jsx(Space, {
          children: /*#__PURE__*/_jsx(ReactToPrint, {
            content: function content() {
              return ref.current;
            },
            children: /*#__PURE__*/_jsx(PrintContextConsumer, {
              children: function children(_ref4) {
                var handlePrint = _ref4.handlePrint;
                return /*#__PURE__*/_jsx(Button, {
                  onClick: handlePrint,
                  type: "ghost",
                  children: /*#__PURE__*/_jsx("b", {
                    children: "IMPRIMER"
                  })
                });
              }
            })
          })
        }),
        children: /*#__PURE__*/_jsx(Receipt, {
          ref: ref,
          order: selectedOrder
        })
      })
    })]
  });
};
export default CustomerDetails;